/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

export const UPCOMING = 1;
export const LIVE = 2;
export const COMPLETED = 3;

export type GameStatusType = ConstantsQuery['game_statuses'][number];

const GAME_STATUSES: GameStatusType[] = [
  {
    id: UPCOMING,
    name: 'Upcoming'
  },
  {
    id: LIVE,
    name: 'Live'
  },
  {
    id: COMPLETED,
    name: 'Completed'
  }
];

export default GAME_STATUSES;
